/**
 * Theme Presets - 主题色方案预设
 * 定义平台支持的多种主题配色
 */

export interface ThemePreset {
  id: string;
  name: string;
  displayColor: string;
}

export const THEME_PRESETS: readonly ThemePreset[] = [
  { id: 'golden-hour', name: 'Golden Hour', displayColor: '#F5A623' },
  { id: 'morandi-blue', name: 'Morandi Blue', displayColor: '#8EA4B8' },
  { id: 'morandi-lavender', name: 'Morandi Lavender', displayColor: '#9B91AB' },
  { id: 'morandi-sage', name: 'Morandi Sage', displayColor: '#8B9E7E' },
  { id: 'morandi-rose', name: 'Morandi Rose', displayColor: '#C9A9A6' },
] as const;

export const DEFAULT_THEME_ID = 'morandi-lavender';

export function getThemePresetById(id: string): ThemePreset | undefined {
  return THEME_PRESETS.find((theme) => theme.id === id);
}

/** Update the <meta name="theme-color"> tag to match the active theme */
export function syncThemeColorMeta(themeId: string): void {
  const preset = getThemePresetById(themeId);
  const color = preset?.displayColor ?? '#9B91AB';
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', color);
  }
}
